import axios from "axios"
import { apiURL } from "./auth"

export const getMe = () => axios.get(`${apiURL}/dj-rest-auth/user/`)

export const cekUser = uname_email =>
  axios.get(`${apiURL}/user/?uname_email=${uname_email}`)

export const getNotifications = () => axios.get(`${apiURL}/notification/`)
